import classNames from 'classnames'
import React, { useState } from 'react'
import { Card, Cards, Column, Grid } from 'src/components/framework/ui'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { useStockReportContext } from 'src/contexts/stock-report.context'
import { SecurityEvent } from 'src/shared/security.dto'

export const EventsList: React.FC = () => {
  const { report } = useStockReportContext()
  const { security } = report

  const [pastEventsVisible, setPastEventsVisible] = useState<boolean>(false)

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      setPastEventsVisible(!pastEventsVisible)
      event.preventDefault()
    }
  }

  return (
    <>
      <Grid>
        <Column>
          <SectionHeader>Upcoming events for {security.ticker}</SectionHeader>
        </Column>
        <Column shrink={'shrink'}>
          {pastEventsVisible ? (
            <a
              className={'stk-text-clickable'}
              role={'button'}
              tabIndex={0}
              onClick={() => setPastEventsVisible(false)}
              onKeyDown={handleKeyDown}
            >
              Hide recent events
            </a>
          ) : (
            <a
              className={'stk-text-clickable'}
              role={'button'}
              tabIndex={0}
              onClick={() => setPastEventsVisible(true)}
              onKeyDown={handleKeyDown}
            >
              Show recent events
            </a>
          )}
        </Column>
      </Grid>
      <Cards variants={['outlined']} className={'stk-space-out-t-2'}>
        <List events={report.events.upcoming} />
        {pastEventsVisible && (
          <>
            <List events={report.events.past} />
          </>
        )}
      </Cards>
    </>
  )
}

interface ListProps {
  events: ReadonlyArray<SecurityEvent>
}

const List: React.FC<ListProps> = ({ events }) => {
  return (
    <Card>
      {events.map((eventItem, index) => (
        <article
          key={index}
          className={classNames({ 'stk-space-out-t-1': index !== 0 })}
        >
          <div className={'stk-text-unimportant stk-text-small'}>
            <time dateTime={eventItem.date}>{eventItem.date}</time>
          </div>
          <h3 className="stk-text-h4">{eventItem.title}</h3>
        </article>
      ))}
    </Card>
  )
}
